import { render, staticRenderFns } from "./ProspectiveExcelUpload.vue?vue&type=template&id=48cbdbbf&scoped=true&"
import script from "./ProspectiveExcelUpload.vue?vue&type=script&lang=js&"
export * from "./ProspectiveExcelUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProspectiveExcelUpload.vue?vue&type=style&index=0&id=48cbdbbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cbdbbf",
  null
  
)

export default component.exports